import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SendConceptForm from "./sendConceptsForm.view";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";
import * as ConceptService from "../../../../services/ConceptServices";
import { HOUR_TYPES } from "../../../../constants";
import * as workingPartService from "../../../../services/WorkingPartServices";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

const SendConceptFormContainer = ({ uuid, onSuccess, array, isMultiple }) => {
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [data, setData] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false);

  const setInitialValues = useCallback(async (data) => {
    if (!data || !data.items) {
      setInitValues({});
      return;
    }

    // Construir valores iniciales a partir de items
    const dataFinal = {};
    data.items.forEach((item, index) => {
      //si item.hoursByType trae un objeto vacío, no se itera sobre él
      // if (item.hoursByType !== {}) {
        Object.entries(item.hoursByType).forEach(([type, hours]) => {
          const key = `${item.nifSociety}_${type}`;
          dataFinal[key] = hours;
        });
      // }
    });

    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid && !isMultiple) {
      const result = await ConceptService.getConceptByUuid(uuid);
      if (result) {
        setData(result);
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid, isMultiple]);

  useEffect(() => {
    loadData();
  }, [loadData, forceRefresh]);

  const confirm = async (values) => {
    try {
      if (!isMultiple) {
        if (values && data) {
          // Reconstruir la estructura items con los valores actualizados
          const updatedItems = data.items.map((item) => {
            const updatedHoursByType = {};
            Object.keys(item.hoursByType).forEach((type) => {
              const key = `${item.nifSociety}_${type}`;
              updatedHoursByType[type] =
                Number(values[key]) || item.hoursByType[type];
            });
            return {
              ...item,
              hoursByType: updatedHoursByType,
            };
          });

          const payload = {
            ...data,
            items: updatedItems,
            dateSend: values.dateSend,
          };

          let result = await workingPartService.sendWorkingPartToA3(payload);

          let title = "";
          let text = "";
          let icon = "";
          if (result) {
            title = t("forms.workingPartDetail.messages.concepts.title");
            text = t("forms.workingPartDetail.messages.concepts.success");
            icon = "success";
          } else {
            title = "Error";
            text = t("forms.workingPartDetail.messages.concepts.error");
            icon = "error";
          }

          let okAction = () => {
            if (onSuccess) {
              onSuccess();
              setForceRefresh(true);
            }
          };
          ShowDialog(title, text, icon, false, "OK", false, okAction);
        }
      } else {
        let title, text, icon;
        const okAction = () => {
          // setSelectedRows({});
          // setSelectAllPages(false);
          // setAllData([]);
          setForceRefresh(true);
        };
        // const okAction = async () => {

        const valuesToSend = {
          uuids: array,
          dateSend: values.dateSend,
        };
        let result = await workingPartService.sendMultipleA3(valuesToSend);
        if (result) {
          title = t("forms.workingPartSnap.messages.sendA3.title");
          text = t("forms.workingPartSnap.messages.sendA3.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.workingPartSnap.messages.sendA3.error");
        }

        showDialog(title, text, icon, false, "OK", false, okAction);

        // };
        // showDialog(
        //   t("forms.workingPartDetail.messages.concepts.title"),
        //   t("forms.workingPartDetail.messages.concepts.confirmText"),
        //   "warning",
        //   true,
        //   t("forms.workingPartDetail.messages.concepts.confirmButton"),
        //   false,
        //   okAction,
        //   t("forms.workingPartDetail.messages.concepts.cancelButton"),
        // );
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const hoursBySocieties = async (data) => {
    const text = data.hoursBySociety
      .map((item) => {
        let societyText = `<strong>${item.societyName}</strong><br />`;

        Object.entries(item.hoursByType).forEach(([type, hours]) => {
          const typeInfo = HOUR_TYPES.find((ht) => ht.code === parseInt(type));
          const typeName = typeInfo ? t(typeInfo.label) : `Tipo ${type}`;
          societyText += `${typeName}: ${hours}${
            type === "8" ? "km" : "h"
          }<br />`;
        });

        return societyText.trim();
      })
      .join(`<br />`);

    return text;
  };

  const handleSubmit = async (values) => {
    const okAction = async () => {
      confirm(values);
    };

    const cancelAction = () => {};

    ShowDialog(
      t("forms.workingPartDetail.messages.concepts.title"),
      // await hoursBySocieties(data),
      t("forms.workingPartDetail.messages.concepts.confirmTextUnique"),
      "warning",
      true,
      t("forms.workingPartDetail.messages.concepts.confirmButton"),
      false,
      okAction,
      t("forms.workingPartDetail.messages.concepts.cancelButton"),
      cancelAction,
    );
  };

  const handleOnback = () => {
    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <SendConceptForm
      initialValues={initValues}
      data={data}
      onSubmit={handleSubmit}
      onback={handleOnback}
      resetRefresh={() => setForceRefresh(false)}
      isMultiple={isMultiple}
    />
  );
};

SendConceptFormContainer.propTypes = {
  t: PropTypes.any,
};

export default SendConceptFormContainer;
